import { hasSlot } from '../../utils/utils.js';
import PendoDivider from '../divider/pendo-divider.vue.js';

var script = {
  name: 'PendoMultiselectOption',
  components: {
    PendoDivider
  },
  inject: ['multiselect'],
  props: {
    option: {
      type: [Object, String, Number],
      required: true
    },
    scrollActive: {
      type: Boolean,
      default: false
    },
    index: {
      type: Number
    }
  },
  computed: {
    optionHeight() {
      return `${this.multiselect.optionHeight}px`;
    },
    dividerWidth() {
      if (this.multiselect.isFullWidth) {
        return '100%';
      }
      return `${this.multiselect.computedMenuWidth || this.multiselect.minMenuWidth}px`;
    },
    showGroupDividers() {
      return this.multiselect.groupDividers;
    },
    allowGroupSelect() {
      return this.multiselect.groupSelect;
    },
    isGroupOption() {
      return this.option.type === 'group';
    },
    isSelected() {
      if (this.isGroupOption && this.allowGroupSelect) {
        const groupValues = this.multiselect.filteredOptions.find(filteredOption => {
          return filteredOption[this.multiselect.groupLabelKey] === this.option.label;
        });
        return this.multiselect.isEntireGroupSelected(groupValues);
      }
      return this.multiselect.isOptionSelected(this.option);
    },
    isDisabled() {
      if (this.option.disabled) {
        return true;
      }
      return this.multiselect.multiple && this.multiselect.max === this.multiselect.model.length;
    },
    isHighlighted() {
      if (this.isGroupOption && !this.allowGroupSelect) {
        return false;
      }
      if (this.isDisabled) {
        return false;
      }
      return this.multiselect.showPointer && this.multiselect.pointer === this.index;
    },
    optionTitle() {
      if (hasSlot(this, 'option')) {
        return;
      }
      return this.optionLabel;
    },
    optionLabel() {
      return this.multiselect.getOptionLabel(this.option);
    },
    groupLabel() {
      return this.option[this.multiselect.groupLabelKey];
    },
    tagPlaceholder() {
      return this.multiselect.tagPlaceholder;
    }
  },
  methods: {
    onOptionSelect() {
      if (this.isGroupOption && !this.allowGroupSelect) {
        return;
      }
      this.multiselect.select(this.option);
    },
    onOptionHover() {
      if (this.scrollActive) {
        return;
      }
      if (this.isGroupOption && !this.allowGroupSelect) {
        return;
      }
      this.multiselect.pointerSet(this.index);
    }
  }
};

export { script as default };
//# sourceMappingURL=pendo-multiselect-option.vue2.js.map
